module.exports = __webpack_public_path__ + "img/xdcb.f2b26be1.png";